import React from 'react';
import PricingHero from '../components/Pricing/PricingHero';
import PricingPhilosophy from '../components/Pricing/PricingPhilosophy';
import WhatIsFree from '../components/Pricing/WhatIsFree';
import StudyAbroadPricing from '../components/Pricing/StudyAbroadPricing';
import WorkAbroadPricing from '../components/Pricing/WorkAbroadPricing';
import WhatWeDoNotChargeFor from '../components/Pricing/WhatWeDoNotChargeFor';
import PaymentTransparency from '../components/Pricing/PaymentTransparency';
import FAQSection from '../components/Pricing/FAQSection';
import CTASection from '../components/Pricing/CTASection';

const Pricing = () => {
  return (
    <div>
      <PricingHero />
      <PricingPhilosophy />
      <WhatIsFree />
      <StudyAbroadPricing />
      <WorkAbroadPricing />
      <WhatWeDoNotChargeFor />
      <PaymentTransparency />
      <FAQSection />
      <CTASection />
    </div>
  );
};

export default Pricing;
